import { useEffect } from "react";

import { useIntl } from "react-intl";

import { getAppVariant } from "../variants/getAppVariant";
import { Variant } from "../variants/variants";

const getEnvironmentPrefix = (): string | null => {
  const env = process.env.ENVIRONMENT;
  if (env === "prod") {
    return null;
  }
  return env?.toUpperCase() ?? null;
};

const TITLE_KEYS: Record<Variant, string> = {
  cleverfarm: "common.metadata.title",
  agrotrade: "common.metadata.agrotrade.title",
  mymex: "common.metadata.mymex.title",
  spzo: "common.metadata.spzo.title",
};

const usePageTitle = (pageTitle?: string): void => {
  const intl = useIntl();
  const variant = getAppVariant();
  const envPrefix = getEnvironmentPrefix();
  const appName = intl.formatMessage({ id: TITLE_KEYS[variant] });

  useEffect(() => {
    const previousTitle = document.title;
    const prefix = envPrefix ? `[${envPrefix}] ` : "";
    const suffix = pageTitle ? ` | ${pageTitle}` : "";
    document.title = `${prefix}${appName}${suffix}`;

    return () => {
      document.title = previousTitle;
    };
  }, [appName, envPrefix, pageTitle]);
};

export { usePageTitle };
